import { _ContentType } from "../content-types/types.js";
import { getValueForUICultureBinder } from "./funcs.js";
_ContentType.prototype.titleResource = getValueForUICultureBinder("nameResource");
_ContentType.prototype.descriptionResource = getValueForUICultureBinder("descriptionResource");
//# sourceMappingURL=content-type.js.map